import { Link } from "react-router-dom";

const NAV_LINKS = [
  { label: "Home", url: "/" },
  { label: "About Us", url: "/about" },
  { label: "Services", url: "/services" },
  { label: "Projects", url: "/projects" },
];

const SERVICES = [
  "Internal Electrification",
  "LT Cabling & Panels",
  "MEP Works",
  "Solar Energy Systems",
  "Fire-Fighting Systems",
  "HVAC Installations",
  "Airport Infrastructure",
];

const SECTORS = [
  { label: "Residential & Housing", key: "residentialHousing" },
  { label: "Hospitals & Hotels",      key: "hospitalityHealthcare" },
  { label: "Corporate Offices",        key: "corporateOffices" },
  { label: "Retail & Malls",           key: "retailCommercial" },
  { label: "Airports",                 key: "airportProjects" },
  { label: "Atomic Energy",            key: "atomicEnergy" },
  { label: "Solar Energy",             key: "solarEnergy" },
  { label: "Industrial & Warehousing", key: "industrialWarehousing" },
];

export default function Footer() {
  return (
    <footer className="bg-gray-950 text-gray-400" aria-label="Site footer">

      {/* Main footer grid */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">

        {/* Brand column */}
        <div className="lg:col-span-1">
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo.png" alt="ATPPL Logo" className="h-10 w-auto" />
            <span className="text-white font-bold text-sm leading-tight">
              Aditya Techno<br />Products Pvt Ltd
            </span>
          </div>
          <p className="text-sm leading-relaxed text-gray-500 mb-6">
            A trusted MEP and electrical contracting company delivering quality infrastructure across India's most demanding sectors since 2007.
          </p>
          {/* Contact quick links */}
          <div className="flex flex-col gap-3 text-sm">
            <a
              href="tel:01204335131"
              className="flex items-center gap-2 hover:text-orange-400 transition-colors duration-200"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              0120-4335131
            </a>
            <a
              href="mailto:info@adityatechno.in"
              className="flex items-center gap-2 hover:text-orange-400 transition-colors duration-200"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              info@adityatechno.in
            </a>
            <span className="flex items-start gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
              New Delhi, India
            </span>
            <a
              href="https://maps.app.goo.gl/gK61HeboZZ5sC37e7"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-start gap-2 hover:text-orange-400 transition-colors duration-200"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              G-102, Plot-123, Sector-06,<br />Vaishali, Ghaziabad,<br />Uttar Pradesh-201010
            </a>
            <span className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Mon – Sat: 10:00 AM – 6:00 PM
            </span>
          </div>
        </div>

        {/* Quick links */}
        <div>
          <h3 className="text-white font-semibold text-sm uppercase tracking-widest mb-5">
            Quick Links
          </h3>
          <ul className="flex flex-col gap-3">
            {NAV_LINKS.map((link) => (
              <li key={link.label}>
                <Link
                  to={link.url}
                  className="text-sm hover:text-orange-400 transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1 h-1 rounded-full bg-orange-500 inline-block shrink-0" />
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h3 className="text-white font-semibold text-sm uppercase tracking-widest mb-5">
            Our Services
          </h3>
          <ul className="flex flex-col gap-3">
            {SERVICES.map((s) => (
              <li key={s}>
                <Link
                  to="/services"
                  className="text-sm hover:text-orange-400 transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1 h-1 rounded-full bg-orange-500 inline-block shrink-0" />
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Sectors */}
        <div>
          <h3 className="text-white font-semibold text-sm uppercase tracking-widest mb-5">
            Sectors
          </h3>
          <ul className="flex flex-col gap-3">
            {SECTORS.map((s) => (
              <li key={s.key}>
                <Link
                  to={`/projects?category=${s.key}`}
                  className="text-sm hover:text-orange-400 transition-colors duration-200 flex items-center gap-2"
                >
                  <span className="w-1 h-1 rounded-full bg-orange-500 inline-block shrink-0" />
                  {s.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

      </div>

      {/* Divider */}
      <div className="border-t border-gray-800" />

      {/* Bottom bar */}
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-600">
        <p>
          © {new Date().getFullYear()} Aditya Techno Products Pvt. Limited. All rights reserved.
        </p>
        <p className="text-center sm:text-right">
          Electrical &amp; MEP Contractors &nbsp;·&nbsp; Pan-India &nbsp;·&nbsp; Est. 2007
        </p>
      </div>

    </footer>
  );
}
